module.exports = __webpack_public_path__ + "img/search.6895cffa.svg";